import React from 'react';
import './Style/AccountDeletion.css'; 
import TopNavbar from '../home/TopNavbar';

const AccountDeletionInstructions = () => {
  const contactEmail = "contact@mystudyplace.online";

  return (
    <div className="account-delete-container">
      <TopNavbar name="Delete Account" />
      
      <div className="account-delete-card">
        <h1>Account Deletion Guide</h1>
        <p className="account-delete-timestamp">Last Updated: October 2026</p>

        <section>
          <h2>Data Deletion Policy</h2>
          <p>
            At <strong>JEE Mock Test</strong>, we respect your privacy and give you full control over your personal data. You can request the complete erasure of your account information at any time. 
          </p>
          <p>
            Please note that executing an account deletion is <strong>permanent and irreversible</strong>. 
          </p>
        </section>

        {/* Highlighted Instruction Section */}
        <section className="account-delete-steps-box">
          <h2>How to Delete Your Account In-App</h2>
          <p>You can delete your account and all associated data directly inside our mobile application by following these steps:</p>
          <ul>
            <li><strong>Step 1:</strong> Open the <strong>JEE Mock Test</strong> app and ensure you are logged into your account.</li>
            <li><strong>Step 2:</strong> Navigate to your <strong>Profile Menu</strong> or <strong>Settings</strong> dashboard.</li>
            <li><strong>Step 3:</strong> Tap on the <strong>"Delete Account"</strong> option located at the bottom of the page.</li>
            <li><strong>Step 4:</strong> Confirm your choice on the security prompt. Your account will be purged instantly.</li>
          </ul>
        </section>

        <section>
          <h2>What Data Gets Deleted</h2>
          <p>Upon account deletion, the following data is permanently purged from our primary database servers:</p>
          <ul>
            <li>Personal Account Details (Full Name, Target Class, Phone Number, Registered Email)</li>
            <li>Authentication Credentials & Saved Tokens</li>
            <li>Mock Test Scores, Subject Analytics, and Progress History</li>
          </ul>
        </section>

        <section>
          <h2>Alternative Web / Email Deletion Request</h2>
          <p>
            If you have uninstalled the app or are unable to access your mobile application, you can submit a manual deletion request by sending an email to our support team:
          </p>
          <p>
            Please email us from your registered email address with the subject <strong>"Account Deletion Request"</strong>:
          </p>
          <p>
            <strong>Email:</strong> <a href={`mailto:${contactEmail}`} className="account-delete-email-btn">{contactEmail}</a>
          </p> 
          <p>Manual requests are processed and verified within 24 to 48 hours.</p>
        </section>
      </div>
    </div>
  );
};

export default AccountDeletionInstructions;